export function jsonCopy<T>(a: T): T {
    return JSON.parse(JSON.stringify(a));
}
